import { Unidade } from '@/domain/models'
import { GetUnits } from '@/domain/usecases'
import { RemoteGetUnits } from '@/data/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import env from '@/main/config/env'

export const makeGetUnits = (): GetUnits => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<Unidade[]>()

  return new RemoteGetUnits(url, httpClient)
}
